import React from "react";
import SelectInput from "@components/inputs/SelectInput/SelectInput";
import TextInput from "@components/inputs/TextInput/TextInput";

export interface AttributionProps {
    source: string;
    setSource: (value: string) => void;
    otherText: string;
    setOtherText: (value: string) => void;
}

const AttributionForm: React.FC<AttributionProps> = ({
    source,
    setSource,
    otherText,
    setOtherText,
}) => {
    const options = [
        { label: "Google Search", value: "Google Search" },
        { label: "funeralquestions.net", value: "funeralquestions.net" },
        { label: "Facebook", value: "Facebook" },
        // { label: "Instagram", value: "Instagram" },
        // { label: "TikTok", value: "TikTok" },
        { label: "Funeral Director", value: "Funeral director" },
        { label: "Recommended by a Friend", value: "Recommended by a friend" },
        { label: "Saw a Funeral Notice", value: "Saw a funeral notice" },
        { label: "Saw a Memorial Page", value: "Saw a memorial page" },
        { label: "Other", value: "Other" },
    ];

    return (
        <div style={{ marginTop: "20px", textAlign: "left" }}>
            <SelectInput
                id="attribution-source"
                label="How did you find us? (optional)"
                value={source}
                onChange={setSource}
                options={options}
                placeholder="Select one..."
            />

            {source === "Other" && (
                <TextInput
                    id="attribution-other"
                    label="Please specify"
                    value={otherText}
                    onChange={setOtherText}
                    placeholder="Please specify"
                />
            )}
        </div>
    );
};

export default AttributionForm;
